/**
 * Reports API client (CR-0015 / Δ-14).
 *
 * CR-0024 (Δ-22, 2026-06-01): the `type` query parameter is no longer
 * threaded from the frontend. The backend defaults to `"waiting"` so
 * the JSON + export endpoints return customer-wait sessions only — the
 * mandatory clause of CR-0021 Option A. The toggle that previously
 * exposed `?type=all` to the UI was rolled back under CR-0024.
 */
import http from "@/api/client";

export async function fetchCurrentDate(from, to) {
  const { data } = await http.get("/reports/current-date", {
    params: { from, to },
  });
  return data;
}

export async function fetchDayWise(from, to) {
  const { data } = await http.get("/reports/day-wise", {
    params: { from, to },
  });
  return data;
}

export function exportUrl(tab, from, to, format) {
  // Build the absolute URL for an export download.
  const base = process.env.REACT_APP_BACKEND_URL;
  const path = tab === "daywise" ? "day-wise" : "current-date";
  const params = new URLSearchParams({ from, to, format });
  return `${base}/api/reports/${path}/export?${params.toString()}`;
}
